// frontend/src/components/common/PageNumberText.tsx

import React from 'react';
import { Box, Typography } from '@mui/material';
import { colors } from '../../theme/theme';

interface PageNumberTextProps {
  current?: number | null;
  total?: number | null;
}

const PageNumberText: React.FC<PageNumberTextProps> = ({ current, total }) => {
  if (!current && !total) return null;

  return (
    <Box
      sx={{
        width: '100%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        pb: '2rem',
        pt: '1rem',
        '@media (max-width:600px)': {
          justifyContent: 'flex-start',
          //   border: '3px dashed red',
          boxShadow: colors.shadows.powerInsetBolder,
          pl: '1rem',
        },
      }}
    >
      <Typography fontWeight={700} fontSize={'1.6rem'} fontStyle={'italic'}>
        Bottom of page
        {current ? ` ${current}` : ''}
        {total ? ` of ${total}` : ''}
      </Typography>
    </Box>
  );
};

export default PageNumberText;
